import React from "react";
import { Link } from "react-router-dom";

export default function RagStudyCard({ study }) {
  if (!study) return null;
  return (
    <div className="rounded-lg bg-primaryBlue bg-opacity-10 border border-primaryBlue p-4 mb-6">
      <div className="font-extrabold text-primaryDark text-lg">
        📅 {study.label || "Today's Study"}
        {study.hebrew_date ? ` — ${study.hebrew_date}` : ""}
      </div>
      {study.kind === "parsha" ? (
        study.category ? (
          <Link
            className="text-primaryBlue hover:underline"
            to={`/category/${study.category.slug ?? study.category.category_id}`}
          >
            {study.category.name}
          </Link>
        ) : null
      ) : (
        <ul className="mt-2 space-y-1">
          {(study.classes || []).map((c) => (
            <li key={c.class_id}>
              <Link
                className="text-primaryBlue hover:underline"
                to={`/${c.permalink ?? c.class_id}`}
              >
                {c.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
